<!-- =========================================================================================
    File Name: Chat.vue
    Description: Chat Application - Stay connected
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div>
  <!-- isThreadACtive: {{isThreadACtive}} -->
  <!-- ChatRelatedTo : {{ChatRelatedTo}} -->
  <!-- {{tabActive}} -->
  <!-- {{UserThreads.length}}
  {{ClientThreads.length}}
  {{GroupThreads.length}} -->
  <!-- {{threadSearchQuery}} -->
    <!-- <pre>ActiveTab : {{this.$store.state.message.ActiveTab}}</pre>
    <pre>User_Active_Thread Id: {{this.$store.state.message.User_Active_Thread}}</pre>
    <pre>Client_Active_Thread Id:{{this.$store.state.message.Client_Active_Thread}}</pre> -->

    <!-- {{user_chat_next_page_url}}
    {{client_chat_next_page_url}} -->
    <!-- <pre>{{this.GroupThreads}}</pre>
    {{group_chat_next_page_url}} -->
<!-- {{isChatSidebarActive}}
{{clickNotClose}} -->
<!-- relatedTo : {{relatedTo}} -->

<!-- <div class="" v-if="courseSidebarStatus || classSidebarStatus"> -->
  <div class="">
<div class="cstm-tab-holder">
    <div class="cstm-unique-tab flex mb-4">
      <div class="flex flex-wrap">
        <div class="tab-name flex items-center" :class="{'activeTab': generalTab}" @click="chatRelatedToTab('general')">
          General
          <span class="cstm-status-badge">{{generalUnreadMessage}}</span>
        </div>
        <div class="tab-name flex items-center" :class="{'activeTab': courseTab}" @click="chatRelatedToTab('course')">
          Course Related Chats
          <span class="cstm-status-badge">{{courseUnreadMessage}}</span>
        </div>
        <div class="tab-name flex items-center" :class="{'activeTab': classTab}" @click="chatRelatedToTab('class')">
          Class Related Chats
          <span class="cstm-status-badge">{{classUnreadMessage}}</span>
        </div>
      </div>
    </div>

    <div class="cstm_all_content_holder">
      <!-- <div v-if="courseTab && courseSidebarStatus"> -->
        <div v-if="courseTab">
        <!-- Course -->
        <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" v-if="chatSidebarShow" id="chat-list-sidebar">
            <!-- {{ Threads }} -->
            <!-- USER PROFILE SIDEBAR -->
            <!-- <user-profile :active="activeProfileSidebar" :userId="userProfileId" class="user-profile-container" :isLoggedInUser="isLoggedInUserProfileView" @closeProfileSidebar="closeProfileSidebar"></user-profile> -->

            <div class="chat__profile-search flex p-4 relative">
                <div class="relative inline-flex">
                  <!-- User Infor : {{userInfo}} -->
                    <vs-avatar v-if="userInfo.picture" class="m-0 border-2 border-solid border-white" :src="userInfo.picture" size="40px" @click="showProfileSidebar(Number(activeUser.uid), true)" />
                    <vs-avatar v-else class="m-0 border-2 border-solid border-white" :src="'http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png'" size="40px" @click="showProfileSidebar(Number(activeUser.uid), true)" />
                    <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(true)"></div>
                </div>

                <vs-input 
                id="chat-search"
                icon-no-border 
                icon="icon-search" 
                icon-pack="feather" 
                class="search_input w-full mx-2 input-rounded-full" 
                placeholder="Search or start a new chat" 
                v-model="threadSearchQuery"
                v-on:keyup="beginSearch"
                />
                <!-- {{threadSearchQuery}} -->
                
                <vs-tooltip text="Create Group" position="top" color="primary">
                <div @click="selectGrp(0)" class="add-user-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
                    <g>
                      <circle class="st0" cx="23.7668304" cy="16.7658215" r="3.9117124"/>
                      <circle class="st0" cx="15.0359392" cy="18.172842" r="3.4143462"/>
                      <path class="st0" d="M14.5730085,27.8318272H8.6240597c0.1302948-2.9983006,2.5952072-5.3910789,5.6256561-5.3910789h1.8419533   c0.5044785,0,0.9911232,0.0718479,1.4561272,0.1962357C15.9412689,23.8709736,14.8346195,25.7187214,14.5730085,27.8318272z"/>
                      <g>
                        <rect x="29.4706535" y="17.9645576" class="st0" width="3.2841055" height="16.5264664"/>
                        
                          <rect x="29.4706535" y="17.9645576" transform="matrix(6.123234e-17 -1 1 6.123234e-17 4.8849168 57.3404961)" class="st0" width="3.2841055" height="16.5264664"/>
                      </g>
                      <path class="st0" d="M21.755434,23.4031296h7.3209591c-1.1529408-1.0823383-2.7014771-1.7476692-4.4088192-1.7476692h-2.1102676   c-3.4718819,0-6.2958698,2.741291-6.4451351,6.1763668h5.6432629V23.4031296z"/>
                    </g>
                  </svg>
                </div>
                </vs-tooltip>

                <!-- <feather-icon class="md:inline-flex lg:hidden -ml-3 cursor-pointer" icon="XIcon" @click="toggleChatSidebar(false)" /> -->
                <!-- <div class="chat-dropdown" :class="{'active': chatDropdown}">
                  <ul>
                    <li v-for="(chatlist, index) in chatlists" :key="index" @click="selectGrp(index)">
                      {{chatlist.title}}
                    </li>
                  </ul>
                </div> -->
            </div>

            <vs-divider class="d-theme-border-grey-light m-0" />
            <vs-tabs v-model="activeTab" alignment="fixed" class="w-100">
              <vs-tab value ="0" :label="instructorOrAdminLabel">
                <!-- <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl"> -->
                <div class="chat-scroll-area cstm_chat_scroll_area pt-4">
                    <!-- ACTIVE CHATS LIST -->
                    <div class="chat__chats-list mb-8">
                      <div v-if="UserThreads.length !== 0">
                        <ul class="chat__active-chats">
                          <li @click="closeChatList" class="cursor-pointer" v-for="(thread, index) in UserThreads" :key="index">
                              <chat-contact :thread="thread" :fetchChat="index === 0 ? true : false" />
                          </li>
                        </ul>
                      </div>
                      <div class="text-center" v-else>
                        No rows to show
                      </div>
                    </div>
                </div>
                <!-- </component> -->
              </vs-tab>

             <vs-tab value ="1" label="Students">
                <!-- <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl"> -->
                <div class="chat-scroll-area cstm_chat_scroll_area pt-4">
                    <!-- ACTIVE CHATS LIST -->
                    <div class="chat__chats-list mb-8">
                      <div v-if="ClientThreads.length !== 0">
                        <ul class="chat__active-chats">
                          <li @click="closeChatList" class="cursor-pointer" v-for="(thread, index) in ClientThreads" :key="index">
                              <chat-contact :thread="thread" :fetchChat="index === 0 ? true : false" />
                          </li>
                        </ul>
                      </div>
                      <div class="text-center" v-else>
                        No rows to show
                      </div>
                    </div>
                </div>
                <!-- </component> -->
              </vs-tab>

              <vs-tab value="2" label="Groups">
                <!-- <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl" id="group-chat-scroll-area"> -->
                <div class="chat-scroll-area cstm_chat_scroll_area pt-4">
                    <!-- ACTIVE CHATS LIST -->
                    <!-- <VuePerfectScrollbar class="chat__chats-list mb-8" @ps-scroll-y="detectScroll"> -->
                    <div class="chat__chats-list mb-8">
                      <div v-if="GroupThreads.length !== 0">
                        <ul class="chat__active-chats">
                          <li @click="closeChatList" class="cursor-pointer" v-for="(thread, index) in GroupThreads" :key="index">
                              <chat-group :thread="thread" :fetchChat="index === 0 ? true : false" />
                          </li>
                        </ul>
                      </div>
                      <div class="text-center" v-else>
                        No rows to show
                      </div>
                    </div>
                    <!-- </VuePerfectScrollbar> -->
                </div>
                <!-- </component> -->

              </vs-tab>
            </vs-tabs>
        </vs-sidebar>
        <div class="no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': active_thread === null}">
            <template v-if="isThreadACtive">
                <!-- <div class="chat__navbar">
                    <chat-navbar :isSidebarCollapsed="!clickNotClose" :user-id="active_thread" :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @showProfileSidebar="showProfileSidebar" @toggleIsChatPinned="toggleIsChatPinned"></chat-navbar>
                </div> -->
                <div class="chat-content-scroll-area border border-solid d-theme-border-grey-light position-relative">
                    <div class="chat__log" ref="chatLog">
                      
                      <message-log @fetchNewChatData="handleFetchNewChatDataEvent" />
                      
                      <!-- mamnja -->
                        <!-- <chat-log :userId="active_thread" v-if="active_thread"></chat-log> -->
                        <vs-button class="lg:hidden chat-back-btn" type="border" icon-pack="feather" icon="icon-chevron-left" @click="chatSidebarShow = true"></vs-button>
                    </div>
                </div>
                <chat-input v-if="chatInputKey"  />
            </template>
            <template v-else>
                <div class="flex flex-col items-center" style="width:100%;">
                  <vs-row vs-justify ="center" class="mb-5">
                    <h4 style="margin-top:50px;font-weight:bolder;color:#304155;">Welcome, {{customer_name}}</h4>
                  </vs-row>
                    <div class="bg-white" style="height:175px;width:175px;border-radius:50%;display: flex;align-items: center;justify-content: center;">
                      <div style="height:100px;width:100px; border-radius:50%;background-color:white;">
                        <div class="relative inline-flex">
                          <vs-avatar class="m-0 border-white border-2 border-solid shadow-md" src="https://i.picsum.photos/id/20/400/400.jpg?hmac=A7YmXnzxu9K5utXf6B0jErut4ApRwfhKMuPwLRWY-Wk" size="100px" />
                          <!-- <div class="h-5 w-5 border-white border-2 border-solid rounded-full absolute right-0 bottom-0 bg-success" :class="'bg-' + red"></div> -->
                      </div>
                      </div>
                    </div>
                    <vs-row vs-justify ="center" class="mt-5">
                    <h3 class="text-grey">Start your conversation</h3>
                  </vs-row>
                    <!-- <vs-button color="primary" type="filled" @click.stop="toggleChatSidebar(true)">Start Conversation</vs-button> -->
                      <!-- <h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" ></h4> -->
                </div>
            </template>
        </div>
        </div>
      </div>
      <!-- <div v-if="classTab && classSidebarStatus"> -->
        <div v-if="classTab">
        <!-- Class -->
        <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" v-if="chatSidebarShow" id="chat-list-sidebar">
            <!-- {{ Threads }} -->
            <!-- USER PROFILE SIDEBAR -->
            <!-- <user-profile :active="activeProfileSidebar" :userId="userProfileId" class="user-profile-container" :isLoggedInUser="isLoggedInUserProfileView" @closeProfileSidebar="closeProfileSidebar"></user-profile> -->

            <div class="chat__profile-search flex p-4 relative">
                <div class="relative inline-flex">
                  <!-- User Infor : {{userInfo}} -->
                    <vs-avatar v-if="userInfo.picture" class="m-0 border-2 border-solid border-white" :src="userInfo.picture" size="40px" @click="showProfileSidebar(Number(activeUser.uid), true)" />
                    <vs-avatar v-else class="m-0 border-2 border-solid border-white" :src="'http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png'" size="40px" @click="showProfileSidebar(Number(activeUser.uid), true)" />
                    <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(true)"></div>
                </div>

                <vs-input 
                id="chat-search"
                icon-no-border 
                icon="icon-search" 
                icon-pack="feather" 
                class="search_input w-full mx-2 input-rounded-full" 
                placeholder="Search or start a new chat" 
                v-model="threadSearchQuery"
                v-on:keyup="beginSearch"
                />
                <!-- {{threadSearchQuery}} -->
                
                <vs-tooltip text="Create Group" position="top" color="primary">
                <div @click="selectGrp(0)" class="add-user-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
                    <g>
                      <circle class="st0" cx="23.7668304" cy="16.7658215" r="3.9117124"/>
                      <circle class="st0" cx="15.0359392" cy="18.172842" r="3.4143462"/>
                      <path class="st0" d="M14.5730085,27.8318272H8.6240597c0.1302948-2.9983006,2.5952072-5.3910789,5.6256561-5.3910789h1.8419533   c0.5044785,0,0.9911232,0.0718479,1.4561272,0.1962357C15.9412689,23.8709736,14.8346195,25.7187214,14.5730085,27.8318272z"/>
                      <g>
                        <rect x="29.4706535" y="17.9645576" class="st0" width="3.2841055" height="16.5264664"/>
                        
                          <rect x="29.4706535" y="17.9645576" transform="matrix(6.123234e-17 -1 1 6.123234e-17 4.8849168 57.3404961)" class="st0" width="3.2841055" height="16.5264664"/>
                      </g>
                      <path class="st0" d="M21.755434,23.4031296h7.3209591c-1.1529408-1.0823383-2.7014771-1.7476692-4.4088192-1.7476692h-2.1102676   c-3.4718819,0-6.2958698,2.741291-6.4451351,6.1763668h5.6432629V23.4031296z"/>
                    </g>
                  </svg>
                </div>
                </vs-tooltip>

                <!-- <feather-icon class="md:inline-flex lg:hidden -ml-3 cursor-pointer" icon="XIcon" @click="toggleChatSidebar(false)" /> -->
                <!-- <div class="chat-dropdown" :class="{'active': chatDropdown}">
                  <ul>
                    <li v-for="(chatlist, index) in chatlists" :key="index" @click="selectGrp(index)">
                      {{chatlist.title}}
                    </li>
                  </ul>
                </div> -->
            </div>

            <vs-divider class="d-theme-border-grey-light m-0" />
            <vs-tabs v-model="activeTab" alignment="fixed" class="w-100">
              <vs-tab value ="0" :label="instructorOrAdminLabel">
                <!-- <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl"> -->
                <div class="chat-scroll-area cstm_chat_scroll_area pt-4">
                    <!-- ACTIVE CHATS LIST -->
                    <div class="chat__chats-list mb-8">
                      <div v-if="UserThreadsClass.length !== 0">
                        <ul class="chat__active-chats">
                          <li @click="closeChatList" class="cursor-pointer" v-for="(thread, index) in UserThreadsClass" :key="index">
                              <chat-contact :thread="thread" :fetchChat="index === 0 ? true : false" />
                          </li>
                        </ul>
                      </div>
                      <div class="text-center" v-else>
                        No rows to show
                      </div>
                    </div>
                </div>
                <!-- </component> -->
              </vs-tab>

               <vs-tab value ="1" label="Students">
                <!-- <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl"> -->
                <div class="chat-scroll-area cstm_chat_scroll_area pt-4">
                    <!-- ACTIVE CHATS LIST -->
                    <div class="chat__chats-list mb-8">
                      <div v-if="ClientThreadsClass.length !== 0">
                        <ul class="chat__active-chats">
                          <li @click="closeChatList" class="cursor-pointer" v-for="(thread, index) in ClientThreadsClass" :key="index">
                              <chat-contact :thread="thread" :fetchChat="index === 0 ? true : false" />
                          </li>
                        </ul>
                      </div>
                      <div class="text-center" v-else>
                        No rows to show
                      </div>
                    </div>
                </div>
                <!-- </component> -->
              </vs-tab>

              <vs-tab value="2" label="Groups">
                <!-- <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl" id="group-chat-scroll-area"> -->
                <div class="chat-scroll-area cstm_chat_scroll_area pt-4">
                    <!-- ACTIVE CHATS LIST -->
                    <!-- <VuePerfectScrollbar class="chat__chats-list mb-8" @ps-scroll-y="detectScroll"> -->
                    <div class="chat__chats-list mb-8">
                      <div v-if="GroupThreadsClass.length !== 0">
                        <ul class="chat__active-chats">
                          <li @click="closeChatList" class="cursor-pointer" v-for="(thread, index) in GroupThreadsClass" :key="index">
                              <chat-group :thread="thread" :fetchChat="index === 0 ? true : false" />
                          </li>
                        </ul>
                      </div>
                      <div class="text-center" v-else>
                        No rows to show
                      </div>
                    </div>
                    <!-- </VuePerfectScrollbar> -->
                </div>
                <!-- </component> -->

              </vs-tab>
            </vs-tabs>
        </vs-sidebar>
        <div class="no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': active_thread === null}">
            <template v-if="isThreadACtive">
                <!-- <div class="chat__navbar">
                    <chat-navbar :isSidebarCollapsed="!clickNotClose" :user-id="active_thread" :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @showProfileSidebar="showProfileSidebar" @toggleIsChatPinned="toggleIsChatPinned"></chat-navbar>
                </div> -->
                <div class="chat-content-scroll-area border border-solid d-theme-border-grey-light position-relative">
                    <div class="chat__log" ref="chatLog">
                      
                      <message-log @fetchNewChatData="handleFetchNewChatDataEvent" />
                      
                      <!-- mamnja -->
                        <!-- <chat-log :userId="active_thread" v-if="active_thread"></chat-log> -->
                        <vs-button class="lg:hidden chat-back-btn" type="border" icon-pack="feather" icon="icon-chevron-left" @click="chatSidebarShow = true"></vs-button>
                    </div>
                </div>
                <chat-input v-if="chatInputKey" />
            </template>
            <template v-else>
                <div class="flex flex-col items-center" style="width:100%;">
                  <vs-row vs-justify ="center" class="mb-5">
                    <h4 style="margin-top:50px;font-weight:bolder;color:#304155;">Welcome, {{customer_name}}</h4>
                  </vs-row>
                    <div class="bg-white" style="height:175px;width:175px;border-radius:50%;display: flex;align-items: center;justify-content: center;">
                      <div style="height:100px;width:100px; border-radius:50%;background-color:white;">
                        <div class="relative inline-flex">
                          <vs-avatar class="m-0 border-white border-2 border-solid shadow-md" src="https://i.picsum.photos/id/20/400/400.jpg?hmac=A7YmXnzxu9K5utXf6B0jErut4ApRwfhKMuPwLRWY-Wk" size="100px" />
                          <!-- <div class="h-5 w-5 border-white border-2 border-solid rounded-full absolute right-0 bottom-0 bg-success" :class="'bg-' + red"></div> -->
                      </div>
                      </div>
                    </div>
                    <vs-row vs-justify ="center" class="mt-5">
                    <h3 class="text-grey">Start your conversation</h3>
                  </vs-row>
                    <!-- <vs-button color="primary" type="filled" @click.stop="toggleChatSidebar(true)">Start Conversation</vs-button> -->
                      <!-- <h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" ></h4> -->
                </div>
            </template>
        </div>
        </div>
      </div>
      <div v-if="generalTab">
        <!-- Class -->
        <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" v-if="chatSidebarShow" id="chat-list-sidebar">
            <!-- {{ Threads }} -->
            <!-- USER PROFILE SIDEBAR -->
            <!-- <user-profile :active="activeProfileSidebar" :userId="userProfileId" class="user-profile-container" :isLoggedInUser="isLoggedInUserProfileView" @closeProfileSidebar="closeProfileSidebar"></user-profile> -->

            <div class="chat__profile-search flex p-4 relative">
                <div class="relative inline-flex img_holder">
                  <!-- User Infor : {{userInfo}} -->
                    <vs-avatar v-if="userInfo.picture" class="m-0 border-2 border-solid border-white" :src="userInfo.picture" size="40px" @click="showProfileSidebar(Number(activeUser.uid), true)" />
                    <vs-avatar v-else class="m-0 border-2 border-solid border-white" :src="'http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png'" size="40px" @click="showProfileSidebar(Number(activeUser.uid), true)" />
                    <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(true)"></div>
                </div>

                <vs-input 
                id="chat-search"
                icon-no-border 
                icon="icon-search" 
                icon-pack="feather" 
                class="search_input w-full mx-2 input-rounded-full" 
                placeholder="Search or start a new chat" 
                v-model="threadSearchQuery"
                v-on:keyup="beginSearch"
                />
                <!-- {{threadSearchQuery}} -->
                
                <vs-tooltip class="create_grp_holder" text="Create Group" position="top" color="primary">
                <div @click="selectGrp(0)" class="add-user-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
                    <g>
                      <circle class="st0" cx="23.7668304" cy="16.7658215" r="3.9117124"/>
                      <circle class="st0" cx="15.0359392" cy="18.172842" r="3.4143462"/>
                      <path class="st0" d="M14.5730085,27.8318272H8.6240597c0.1302948-2.9983006,2.5952072-5.3910789,5.6256561-5.3910789h1.8419533   c0.5044785,0,0.9911232,0.0718479,1.4561272,0.1962357C15.9412689,23.8709736,14.8346195,25.7187214,14.5730085,27.8318272z"/>
                      <g>
                        <rect x="29.4706535" y="17.9645576" class="st0" width="3.2841055" height="16.5264664"/>
                        
                          <rect x="29.4706535" y="17.9645576" transform="matrix(6.123234e-17 -1 1 6.123234e-17 4.8849168 57.3404961)" class="st0" width="3.2841055" height="16.5264664"/>
                      </g>
                      <path class="st0" d="M21.755434,23.4031296h7.3209591c-1.1529408-1.0823383-2.7014771-1.7476692-4.4088192-1.7476692h-2.1102676   c-3.4718819,0-6.2958698,2.741291-6.4451351,6.1763668h5.6432629V23.4031296z"/>
                    </g>
                  </svg>
                </div>
                </vs-tooltip>

                <!-- <feather-icon class="md:inline-flex lg:hidden -ml-3 cursor-pointer" icon="XIcon" @click="toggleChatSidebar(false)" /> -->
                <!-- <div class="chat-dropdown" :class="{'active': chatDropdown}">
                  <ul>
                    <li v-for="(chatlist, index) in chatlists" :key="index" @click="selectGrp(index)">
                      {{chatlist.title}}
                    </li>
                  </ul>
                </div> -->
            </div>

            <vs-divider class="d-theme-border-grey-light m-0" />
            <vs-tabs v-model="activeTab" alignment="fixed" class="chat_tabs_holder w-100">
              <vs-tab value ="0" :label="instructorOrAdminLabel">
                <!-- <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl"> -->
                <div class="chat-scroll-area cstm_chat_scroll_area pt-4">
                    <!-- ACTIVE CHATS LIST -->
                    <div class="chat__chats-list mb-8">
                      <div v-if="UserThreadsGeneral.length !== 0">
                        <ul class="chat__active-chats">
                          <li @click="closeChatList" class="cursor-pointer" v-for="(thread, index) in UserThreadsGeneral" :key="index">
                              <chat-contact :thread="thread" :fetchChat="index === 0 ? true : false" />
                          </li>
                        </ul>
                      </div>
                      <div class="text-center" v-else>
                        No rows to show
                      </div>
                    </div>
                </div>
                <!-- </component> -->
              </vs-tab>

               <vs-tab value ="1" label="Students">
                <!-- <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl"> -->
                <div class="chat-scroll-area cstm_chat_scroll_area pt-4">
                    <!-- ACTIVE CHATS LIST -->
                    <div class="chat__chats-list mb-8">
                      <div v-if="ClientThreadsGeneral.length !== 0">
                        <ul class="chat__active-chats">
                          <li @click="closeChatList" class="cursor-pointer" v-for="(thread, index) in ClientThreadsGeneral" :key="index">
                              <chat-contact :thread="thread" :fetchChat="index === 0 ? true : false" />
                          </li>
                        </ul>
                      </div>
                      <div class="text-center" v-else>
                        No rows to show
                      </div>
                    </div>
                </div>
                <!-- </component> -->
              </vs-tab>

              <vs-tab value="2" label="Groups">
                <!-- <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl" id="group-chat-scroll-area"> -->
                <div class="chat-scroll-area cstm_chat_scroll_area pt-4">
                    <!-- ACTIVE CHATS LIST -->
                    <!-- <VuePerfectScrollbar class="chat__chats-list mb-8" @ps-scroll-y="detectScroll"> -->
                    <div class="chat__chats-list mb-8">
                      <div v-if="GroupThreadsGeneral.length !== 0">
                        <ul class="chat__active-chats">
                          <li @click="closeChatList" class="cursor-pointer" v-for="(thread, index) in GroupThreadsGeneral" :key="index">
                              <chat-group :thread="thread" :fetchChat="index === 0 ? true : false" />
                          </li>
                        </ul>
                      </div>
                      <div class="text-center" v-else>
                        No rows to show
                      </div>
                    </div>
                    <!-- </VuePerfectScrollbar> -->
                </div>
                <!-- </component> -->

              </vs-tab>
            </vs-tabs>
        </vs-sidebar>
        <div class="no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': active_thread === null}">
            <template v-if="isThreadACtive">
                <!-- <div class="chat__navbar">
                    <chat-navbar :isSidebarCollapsed="!clickNotClose" :user-id="active_thread" :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @showProfileSidebar="showProfileSidebar" @toggleIsChatPinned="toggleIsChatPinned"></chat-navbar>
                </div> -->
                <div class="chat-content-scroll-area border border-solid d-theme-border-grey-light position-relative">
                    <div class="chat__log" ref="chatLog">
                      
                      <message-log @fetchNewChatData="handleFetchNewChatDataEvent" />
                      
                      <!-- mamnja -->
                        <!-- <chat-log :userId="active_thread" v-if="active_thread"></chat-log> -->
                        <vs-button class="lg:hidden chat-back-btn" type="border" icon-pack="feather" icon="icon-chevron-left" @click="chatSidebarShow = true"></vs-button>
                    </div>
                </div>
                <chat-input v-if="chatInputKey" />
            </template>
            <template v-else>
                <div class="flex flex-col items-center" style="width:100%;">
                  <vs-row vs-justify ="center" class="mb-5">
                    <h4 style="margin-top:50px;font-weight:bolder;color:#304155;">Welcome, {{customer_name}}</h4>
                  </vs-row>
                    <div class="bg-white" style="height:175px;width:175px;border-radius:50%;display: flex;align-items: center;justify-content: center;">
                      <div style="height:100px;width:100px; border-radius:50%;background-color:white;">
                        <div class="relative inline-flex">
                          <vs-avatar class="m-0 border-white border-2 border-solid shadow-md" src="https://i.picsum.photos/id/20/400/400.jpg?hmac=A7YmXnzxu9K5utXf6B0jErut4ApRwfhKMuPwLRWY-Wk" size="100px" />
                          <!-- <div class="h-5 w-5 border-white border-2 border-solid rounded-full absolute right-0 bottom-0 bg-success" :class="'bg-' + red"></div> -->
                      </div>
                      </div>
                    </div>
                    <vs-row vs-justify ="center" class="mt-5">
                    <h3 class="text-grey">Start your conversation</h3>
                  </vs-row>
                    <!-- <vs-button color="primary" type="filled" @click.stop="toggleChatSidebar(true)">Start Conversation</vs-button> -->
                      <!-- <h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" ></h4> -->
                </div>
            </template>
        </div>
        </div>
      </div>
    </div>
</div>
</div>

<!-- <div class="" 
v-if="!courseSidebarStatus && !classSidebarStatus"
style="text-align: center; margin-top:50px; box-shadow: 0 4px 25px rgba(255, 0, 0, 0.2)">
  <vs-card style="text-align: center;padding: 50px !important">
    <span class="material-icons-outlined" style="color: red; font-size: 120px;">speaker_notes_off</span>
    <h2 style="color: red; padding: 10px 0 20px;">No chat to display.</h2>
    <h5 style="color: rgba(0, 0, 0, 0.5); font-style: italic;">Please join a course or class to initiate chat with its users.</h5>
  </vs-card>
</div> -->

        <!-- modal -->
        <vs-popup class="chat-modal" title="Group" :active.sync="grpChatActive">
         
          <div class="bothChat" v-if="chatModal">
            <div v-if="!chatList">
              <div class="blue-bg">
                <div class="image-holder">
                  <!-- <img width="110" src="https://scoolio-files.s3.ap-south-1.amazonaws.com/20201027120008350001/Default/7eWD1zcDwXfAbGLL.png"> -->
                  <span style="color: rgba(var(--vs-primary), 1); font-size: 80px;" class="material-icons-outlined">groups</span>
                </div>
              </div>
              <vs-input v-if="!addingUsersToGroup" class="w-full" placeholder="Group Name (Min 5 Characters)" v-model="groupName" />
              <div class="my-4">
                <vs-button class="cstm-btn ml-auto" :class="[this.groupName === '' ? 'disabled' : this.groupName.length < 5 ? 'disabled' : '']" @click="chatList = true" icon-pack="feather" icon="icon-chevrons-right"></vs-button>
                <!-- <span v-if="this.groupName.length < 5" style="color:red">Group name must be of min 5 characters</span> -->
              </div>
            </div>
            <div v-if="chatList" class="relative">
              <!-- <vs-input class="w-full mb-4" placeholder="Search" v-model="searchQuery" /> -->
              <vs-button v-if="!addingUsersToGroup" class="back-btn" @click="chatList = false" type="border" icon-pack="feather" icon="icon-chevron-left"></vs-button>

              <!-- <h6 class="pt-12">Suggested</h6> -->
              
              <!-- {{selectedUsers1}} -->
              <div class="pt-12">
                <h6 class="mb-4" v-if="selectedUsers1.length != 0">{{instructorOrAdminLabel}}</h6>
                <div class="flex flex-wrap mb-4">
                  <div class="text-center mr-1" v-for="(selectedUser, index) in selectedUsers1" :key="index">
                    <div class="selected-names">
                      <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p>
                      <span @click="closeSelectedUsers1(index)" class="close">&times;</span>
                    </div>
                    <p class="name-selected">
                      {{selectedUser.first_name}} 
                      {{selectedUser.last_name}}
                    </p>
                  </div>
                </div>

                    <!-- {{selectedClients1}} -->
                <h6 class="mb-4" v-if="selectedClients1.length != 0">Students</h6>
                <div class="flex flex-wrap mb-4">
                  <div class="text-center mr-1" v-for="(selectedUser, index) in selectedClients1" :key="index">
                    <div class="selected-names">
                      <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p>
                      <span @click="closeSelectedClients1(index)" class="close">&times;</span>
                    </div>
                    <p class="name-selected">
                      {{selectedUser.first_name}} 
                      {{selectedUser.last_name}}
                    </p>
                  </div>
                </div>
              </div>

              <vs-tabs>
                <vs-tab :label="instructorOrAdminLabel">
                  <div class="tab-text">
                    <vs-table class="user-table" multiple search v-model="selectedUsers1" :data="relatedTo === 1 ? UserThreads : relatedTo === 2 ? UserThreadsClass : UserThreadsGeneral">
                      <template slot-scope="{data}">
                        <vs-tr :data="thread" v-for="(thread, index) in data" :key="index">
                          <vs-td>
                            <div class="flex items-center">
                              <vs-avatar class="border-2 border-solid border-white" :src="thread.picture" size="40px" />
                              {{thread.first_name}}
                              {{thread.last_name}}
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </vs-tab>

                <vs-tab label="Students">
                  <div class="tab-text">
                    <vs-table class="user-table" multiple search v-model="selectedClients1" :data="relatedTo === 1 ? ClientThreads : relatedTo === 2 ? ClientThreadsClass : ClientThreadsGeneral">
                      <template slot-scope="{data}">
                        <vs-tr :data="thread" v-for="(thread, index) in data" :key="index">
                          <vs-td>
                            <div class="flex items-center">
                              <vs-avatar class="border-2 border-solid border-white" :src="thread.picture" size="40px" />
                              {{thread.first_name}}
                              {{thread.last_name}}
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </vs-tab>
              </vs-tabs>
  
              <vs-button v-if="!addingUsersToGroup" class="add-btn p-3" @click="createChatGroup" :class="[this.selectedUsers1.length === 0 && this.selectedClients1.length === 0 ? 'disabled' : '']">Create Group</vs-button>

              <vs-button v-if="addingUsersToGroup" class="add-btn p-3" @click="addUserToGroup" :class="[this.selectedUsers1.length === 0 && this.selectedClients1.length === 0 ? 'disabled' : '']">Add User</vs-button>

            </div>
          </div>
        </vs-popup>
    </div>
</template>

<script>

import {EventBus} from './mixin/EventBus'
import chatGroup           from './chatGroup'
import ChatContact         from './ChatContact.vue'
import ChatLog             from './ChatLog.vue'
import ChatNavbar          from './ChatNavbar.vue'
import UserProfile         from './UserProfile.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleChat          from '@/store/chat/moduleChat.js'
import chatInput from './chatInput.vue'
import messageLog from './messageLog.vue'
import {mapActions, mapGetters} from 'vuex'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import {messageMixin} from './mixin/messageMixin'

import { 
  fetch_user_list_general,
  fetch_user_list,
  createChatGroup, 
  fetchGroupThreads, 
  addUserToGroup,
  searchUserThread,
  searchClientThread,
  searchGroupThread,
  searchThreadGeneral,
  get_chat_bar,
  readChatMessage
} from '@/api/message'


export default {
  data () {
    return {
      chatInputKey: true,
      userInfo: JSON.parse(localStorage.userInfo),
      instructorOrAdminLabel: 'Instructors',
      courseTab: true,
      classTab: false,
      generalTab: false,
      relatedTo:1,
      courseUnreadMessage: 0,
      classUnreadMessage: 0,
      generalUnreadMessage: 0,
      courseSidebarStatus:false,
      classSidebarStatus:false,
      threadSearchQuery:'',
      addingUsersToGroup:false,
      GroupThreadsArr:[],
      user_chat_next_page_url:null,
      client_chat_next_page_url:null,
      group_chat_next_page_url:null,
      customer_name: '',
      active               : true,
      isHidden             : false,
      searchContact        : '',
      activeProfileSidebar : false,
      activeChatUser       : null,
      userProfileId        : -1,
      typedMessage         : '',
      isChatPinned         : false,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.70
      },
      clickNotClose        : false,
      isChatSidebarActive  : false,
      chatSidebarShow: true,
      isLoggedInUserProfileView: false,
      tab:0,
      chatlists: [{title: 'New Chat Group'}],
      grpChatActive: false,
      userGrp: false,
      clientGrp: false,
      chatModal: false,
      groupName: '',
      userchatList: false,
      clientchatList: false,
      chatList: false,
      selectedUsers: [],
      selectedClients: [],
      selectedUsers1: [],
      selectedClients1: [],
      chatDropdown: false
    }
  },
  mixins: [PermissionMiddleware, messageMixin],
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    },
    activeTab () {
      // // console.log(this.activeTab)
      // if (this.UserThreads.length === 0 || this.UserThreadsClass.length === 0 || this.ClientThreads.length === 0 || this.ClientThreadsClass.length === 0 || this.GroupThreads.length === 0) {
      //   this.fetchThreads()
      //   // console.log('Some Threads Not Fetched')
      // } else {
      //   // console.log('All Threads Fetched')
      // }
      this.fetchThreads()
      // this.reRenderChatInput()    
      setTimeout(() => {
        this.SET_USER_ACTIVE_THREAD(null)
        this.SET_CLIENT_ACTIVE_THREAD(null)
        this.SET_GROUP_ACTIVE_THREAD(null)
        this.SET_ACTIVE_SINGLE_THREAD_DETAILS('')
        this.isThreadACtive()
      }, 0) 
    },
    relatedTo () {
     
      this.fetchThreads()

      //Checking if logged user is admin or staff and assigning Tab label text
      this.instructorOrAdminLabel = (!this.schoolAdmin && this.ChatRelatedTo === 1) ? 'Admin' : 'Instructors'
      // this.reRenderChatInput()      
    },
    UserActiveThread () {
      // this.reRenderChatInput()
    },
    ClientActiveThread () {
      // this.reRenderChatInput()
    },
    GroupActiveThread () {
      // this.reRenderChatInput()
    }
  },
  computed: {
    ...mapGetters(['ChatRelatedTo', 'UserThreads', 'ClientThreads', 'UserThreadsClass', 'ClientThreadsClass', 'UserThreadsGeneral', 'ClientThreadsGeneral', 'GroupThreads', 'GroupThreadsClass', 'GroupThreadsGeneral', 'active_thread', 'tabActive', 'UserActiveThread', 'ClientActiveThread', 'GroupActiveThread', 'get_userinfo_data']),
    activeTab: {
      get () {
        return this.tabActive
      },
      set (value) {
        this.SET_ACTIVE_TAB(value)
      }
    },
    isThreadACtive () {
      if (this.tabActive === 0) {
        if (this.UserActiveThread) {
          return true
        } else {
          return false
        }
      } else if (this.tabActive === 1) {
        if (this.ClientActiveThread) {
          return true
        } else {
          return false
        }
      } else if (this.tabActive === 2) {
        if (this.GroupActiveThread) {
          return true
        } else {
          return false
        }
      }
    },
    chatLastMessaged () {
      return (userId) => this.$store.getters['chat/chatLastMessaged'](userId)
    },
    chatUnseenMessages () {
      return (userId) => {
        const unseenMsg = this.$store.getters['chat/chatUnseenMessages'](userId)
        if (unseenMsg) return unseenMsg
      }
    },
    activeUser () {
      return this.$store.state.AppActiveUser
    },
    getStatusColor () {
      return (isActiveUser) => {
        const userStatus = this.getUserStatus(isActiveUser)

        if (userStatus === 'online') {
          return 'success'
        } else if (userStatus === 'do not disturb') {
          return 'danger'
        } else if (userStatus === 'away') {
          return 'warning'
        } else {
          return 'grey'
        }
      }
    },
    chatContacts () {
      return this.$store.getters['chat/chatContacts']
    },
    contacts () {
      return this.$store.getters['chat/contacts']
    },
    searchQuery: {
      get () {
        return this.$store.state.chat.chatSearchQuery
      },
      set (val) {
        this.$store.dispatch('chat/setChatSearchQuery', val)
      }
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    isActiveChatUser () {
      return (userId) => userId === this.activeChatUser
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  mounted () {
    //Checking if logged user is admin or staff and assigning Tab label text
    this.instructorOrAdminLabel = (!this.schoolAdmin && this.ChatRelatedTo === 1) ? 'Admin' : 'Instructors'
    
    if (this.ChatRelatedTo === 1) {
      this.chatRelatedToTab('course')
    } else if (this.ChatRelatedTo === 2) {
      this.chatRelatedToTab('class')
    } else if (this.ChatRelatedTo === 0) {
      this.chatRelatedToTab('general')
    }
    // this.customer_name = JSON.parse(localStorage.customer_name)
    const customer_details = JSON.parse(localStorage.getItem('userInfo'))
    this.customer_name = `${customer_details.first_name} ${customer_details.last_name}`
    
    this.fetchThreadsAtMount('User', 1).then(() => {
      this.fetchThreadsAtMount('Client', 1).then(() => {
        this.fetchThreadsAtMount('Group', 1).then(() => {
        })
      })
    })

    this.fetchThreadsAtMount('User', 2).then(() => {
      this.fetchThreadsAtMount('Client', 2).then(() => {
        this.fetchThreadsAtMount('Group', 2).then(() => {
        })
      })
    })

    this.fetchThreadsAtMount('User', 0).then(() => {
      this.fetchThreadsAtMount('Client', 0).then(() => {
        this.fetchThreadsAtMount('Group', 0).then(() => {
        })
      })
    })


    EventBus.$on('addGroupUser', () => {
      this.addingUsersToGroup = true
      const group_id = this.GroupActiveThread
      console.log(group_id)
      
      this.selectGrp(0)
      this.chatList = true
    })

    EventBus.$on('groupDeleted', () => {
      this.fetchThreads() 
    })


    EventBus.$on('readChatMessageEvent', () => {
      this.get_chat_bar()
    })

    this.get_chat_bar()

  },
  methods: {
    async handleFetchNewChatDataEvent (chatData) {
      // console.log('=== handleFetchNewChatDataEvent ===', chatData)
      const all_group_threads_id = this.GroupThreads.map((ele) => {
        return ele.group_id
      })

      const all_genera_group_threads_id = this.GroupThreadsGeneral.map((ele) => {
        return ele.group_id
      })

      if (!chatData.to_user) {
        if (all_group_threads_id.includes(chatData.group_id) || all_genera_group_threads_id.includes(chatData.group_id)) {
          this.fetchThreads() 
          this.get_chat_bar()
          // console.log('Group Chat Data', chatData)
        }
      } else if (chatData.to_user === this.userInfo.id) {
        
        try {
          let user_group_id = null
          if (this.tabActive === 0) {
            user_group_id = this.UserActiveThread
          } else if (this.tabActive === 1) {
            user_group_id = this.ClientActiveThread
          } else if (this.tabActive === 2) {
            user_group_id = this.GroupActiveThread
          }

          const payload = {
            to_user : user_group_id,
            from_user_type :chatData.to_user_type,
            to_user_type: chatData.from_user_type
          }

          if (typeof user_group_id === 'number') {
            const data = await readChatMessage(payload)
          // console.log('ReadChatMessage Response', data)
          }

          //Fetching unread message count and thread list
          this.fetchThreads() 
          this.get_chat_bar()
        // console.log('User Chat Data', chatData)
        
        } catch (e) {
          console.log('= Read Chat Error = ', e)
        }

      }
    },
    reRenderChatInput () {
      this.chatInputKey = false
      setTimeout(() => {
        this.chatInputKey = true
      }, 0)
    },
    chatRelatedToTab (type) {
      
      const PreviousRoute = localStorage.getItem('PreviousRoute')
      if (!PreviousRoute) {
        setTimeout(() => {
          this.SET_USER_ACTIVE_THREAD(null)
          this.SET_CLIENT_ACTIVE_THREAD(null)
          this.SET_GROUP_ACTIVE_THREAD(null)
          this.SET_ACTIVE_SINGLE_THREAD_DETAILS('')
          this.isThreadACtive()
        }, 0)
      } else {
        localStorage.removeItem('PreviousRoute')
      }

      this.get_chat_bar() //Used to get total un read messages in each Chat related to section (Courses / Class)
      
      this.selectedUsers1 = []
      if (type === 'course') {
        this.courseTab = true
        this.classTab = false
        this.generalTab = false
        this.relatedTo = 1
        this.SET_CHAT_RELATED_TO(this.relatedTo)
      } else if (type === 'class') {
        this.courseTab = false
        this.classTab = true
        this.generalTab = false
        this.relatedTo = 2
        this.SET_CHAT_RELATED_TO(this.relatedTo)
      }  else if (type === 'general') {
        this.courseTab = false
        this.classTab = false
        this.generalTab = true
        this.relatedTo = 0
        this.SET_CHAT_RELATED_TO(this.relatedTo)
      }
    },
    async get_chat_bar () {
      try {
        const {data} = await get_chat_bar()
        // console.log(data)
        this.courseUnreadMessage = data.data.details.courseUnreadMessage
        this.classUnreadMessage =  data.data.details.classUnreadMessage
        this.generalUnreadMessage = data.data.details.generalUnreadMessage

        this.courseSidebarStatus = data.data.details.courseSidebarStatus
        this.classSidebarStatus = data.data.details.classSidebarStatus
        
      } catch (e) {
        console.log(e)
      }
    },
    async fetch_user_list (tabactive, relatedTo) {
      // console.log('Inside fetch_user_list')
      const customer_id = localStorage.getItem('customer_id')
      try {
        const {data} = await fetch_user_list(customer_id, tabactive, relatedTo)
        // console.log('fetch_user_list data', data)
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      }
    },
    ...mapActions(['SET_CHAT_RELATED_TO', 'SET_USERS_THREADS', 'SET_USERS_THREADS_CLASS', 'SET_GROUP_THREADS', 'SET_CLIENT_THREADS', 'SET_CLIENT_THREADS_CLASS', '', 'SET_USERS_THREADS_GENERAL', 'SET_CLIENT_THREADS_GENERAL', 'SET_GROUP_THREADS_GENERAL', 'SET_ADMIN_ACTIVE_THREAD', 'SET_STAFF_ACTIVE_THREAD', 'SET_CLIENT_ACTIVE_THREAD', 'SET_ACTIVE_TAB', 'SET_USER_ACTIVE_THREAD', 'SET_CLIENT_ACTIVE_THREAD', 'SET_GROUP_ACTIVE_THREAD', 'SET_ACTIVE_SINGLE_THREAD_DETAILS']),
    
    async beginSearch () {
      try {
        // this.$vs.loading()
        setTimeout(() => {
          this.fetchThreads()
        }, 1500)
      } catch (e) {
        console.log(e)
      }

    },

    //To detect scoll of group thread div
    detectScroll (el) {
      if ((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
        if (this.group_chat_next_page_url !== null) {
          this.fetchThreads()
        }
      }
    },
    async fetchThreads () {
      
      try {
        // this.$vs.loading()
        const search_keyword = this.threadSearchQuery
        let data  = ''
        const customer_id = localStorage.getItem('customer_id')
        // console.log(this.activeTab)
        let tabactive = null
        if (this.tabActive === 0) {
          tabactive = 'User'
        } else if (this.tabActive === 1) {
          tabactive = 'Client'
        } else if (this.tabActive === 2) {
          tabactive = 'User'
        }

        
        if (this.tabActive === 0) {
          if (search_keyword === '') {
            //Fetching Users or Client Thread List
            if (this.relatedTo === 0) {
              data = await fetch_user_list_general(customer_id, tabactive)
            } else {
              data = await fetch_user_list(customer_id, tabactive, this.relatedTo)
            }
          } else if (this.relatedTo === 0) {
            data = await searchThreadGeneral(customer_id, tabactive, search_keyword)
          } else {
            data = await searchUserThread(customer_id, this.relatedTo, search_keyword)
          }
        } else if (this.tabActive === 1) {
          if (search_keyword === '') {
            //Fetching Users or Client Thread List
            if (this.relatedTo === 0) {
              data = await fetch_user_list_general(customer_id, tabactive)
            } else {
              data = await fetch_user_list(customer_id, tabactive, this.relatedTo)
            }
          } else if (this.relatedTo === 0) {
            data = await searchThreadGeneral(customer_id, tabactive, search_keyword)
          } else {
            data = await searchClientThread(customer_id, this.relatedTo, search_keyword)
          }
        } else if (this.tabActive === 2) {
          if (search_keyword === '') {
            data = await fetchGroupThreads(customer_id, tabactive, this.group_chat_next_page_url, this.relatedTo)
          } else {
            data = await searchGroupThread(customer_id, this.relatedTo, search_keyword)
          }
        }

        if (this.tabActive === 0) {
          if (this.relatedTo === 1) {
            this.SET_USERS_THREADS(data.data.data.results)
          } else if (this.relatedTo === 2) {
            this.SET_USERS_THREADS_CLASS(data.data.data.results)
          } else if (this.relatedTo === 0) {
            this.SET_USERS_THREADS_GENERAL(data.data.data.results)
          }
          this.user_chat_next_page_url = data.data.data.meta.next_page_url
        } else if (this.tabActive === 1) {
          if (this.relatedTo === 1) {
            this.SET_CLIENT_THREADS(data.data.data.results)
          } else if (this.relatedTo === 2) {
            this.SET_CLIENT_THREADS_CLASS(data.data.data.results)
          } else if (this.relatedTo === 0) {
            this.SET_CLIENT_THREADS_GENERAL(data.data.data.results)
          }
          this.client_chat_next_page_url = data.data.data.meta.next_page_url
        } else if (this.tabActive === 2) {
          if (this.relatedTo === 0) {
            this.SET_GROUP_THREADS_GENERAL(data.data.data.group_list)
          } else {
            this.SET_GROUP_THREADS(data.data.data.group_list)
          }
          if (data.data.data.meta.has_next) {
            this.group_chat_next_page_url = data.data.data.meta.next_page_url
          } else {
            this.group_chat_next_page_url = null
          }
          
        }
      } catch (e) {
        console.error(e)
        if (e.data.message === 'search string length must be grated then 3!') {
          this.$vs.notify({
            title: 'Warning',
            text: 'Search with minumum 3 characters',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        }
      } finally {
        this.$vs.loading.close()
      }
    },
    async fetchThreadsAtMount (type, relatedTo) {
      
      try {
        
        //this.$vs.loading()
        let data  = ''
        const customer_id = localStorage.getItem('customer_id')
        if (type === 'User') {
          try {
            if (relatedTo === 0) {
              data = await fetch_user_list_general(customer_id, type)
            } else {
              data = await fetch_user_list(customer_id, type, relatedTo)
            }
            
            if (relatedTo === 1) {
              this.SET_USERS_THREADS(data.data.data.results)
            } else if (relatedTo === 2) {
              this.SET_USERS_THREADS_CLASS(data.data.data.results)
            } else if (relatedTo === 0) {
              this.SET_USERS_THREADS_GENERAL(data.data.data.results)
            }
            this.user_chat_next_page_url = data.data.data.meta.next_page_url
          } catch (e) {
            console.log(e)
          }

        } else if (type === 'Client') {
          try {
            if (relatedTo === 0) {
              data = await fetch_user_list_general(customer_id, type)
            } else {
              data = await fetch_user_list(customer_id, type, relatedTo)
            }
            if (relatedTo === 1) {
              this.SET_CLIENT_THREADS(data.data.data.results)
            } else if (relatedTo === 2) {
              this.SET_CLIENT_THREADS_CLASS(data.data.data.results)
            } else if (relatedTo === 0) {
              this.SET_CLIENT_THREADS_GENERAL(data.data.data.results)
            }
            this.client_chat_next_page_url = data.data.data.meta.next_page_url
           
          } catch (e) {
            console.log(e)
          }

        } else if (type === 'Group') {
          try {
            type = 'User'
            data = await fetchGroupThreads(customer_id, type, this.group_chat_next_page_url, this.relatedTo)
            if (this.relatedTo === 0) {
              this.SET_GROUP_THREADS_GENERAL(data.data.data.group_list)
            } else {
              this.SET_GROUP_THREADS(data.data.data.group_list)
            }
          } catch (e) {
            console.log(e)
          }
          
          if (data.data.data.meta.has_next) {
            this.group_chat_next_page_url = data.data.data.meta.next_page_url
          } else {
            this.group_chat_next_page_url = null
          }
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.$vs.loading.close()
      }
    },
    clearChatSelectionDetails () {
      this.groupName = ''
      this.chatList = false
      this.grpChatActive = false
      this.chatDropdown = false
      this.chatModal = false
      this.selectedUsers1 = []
      this.selectedClients1 = []
    },
    async addUserToGroup () {
    
      try {
        const group_id = this.GroupActiveThread      
        const selected_group_user = this.selectedUsers1.map((user) => {
          const user_id  = user.user_id
          return {
            user_id,
            type:'User'
          }
        })

        const selected_group_client = this.selectedClients1.map((client) => {
          const user_id  = client.user_id
          return {
            user_id,
            type:'Client'
          }
        })
        // 
        // 
        const group_user_client = selected_group_user.concat(selected_group_client) 
        // 

        const payload = {
          group_id, 
          'user_list' : group_user_client,
          'customer_id' : localStorage.getItem('customer_id')
        }
        const data =  await addUserToGroup(payload)

        this.$vs.notify({
          title: 'Success',
          text: 'User added successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        // 
        EventBus.$emit('groupUserAddedSuccess')
        this.clearChatSelectionDetails()

      } catch (e) {
        

        let errorText = 'Something went wrong'
        if (e.data.message === 'User already exists!') {
          errorText = 'User already exists!'
        }

        this.$vs.notify({
          title: 'Error',
          text: errorText,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    },
    getUserStatus (isActiveUser) {
      // return "active"
      return isActiveUser ? this.$store.state.AppActiveUser.status : this.contacts[this.activeChatUser].status
    },
    closeProfileSidebar (value) {
      this.activeProfileSidebar = value
    },
    updateActiveChatUser (contactId) {
      this.activeChatUser = contactId
      if (this.$store.getters['chat/chatDataOfUser'](this.activeChatUser)) {
        this.$store.dispatch('chat/markSeenAllMessages', contactId)
      }
      const chatData = this.$store.getters['chat/chatDataOfUser'](this.activeChatUser)
      if (chatData) this.isChatPinned = chatData.isPinned
      else this.isChatPinned = false
      this.toggleChatSidebar()
      this.typedMessage = ''
    },
    showProfileSidebar (userId, openOnLeft = false) {
      this.userProfileId = userId
      this.isLoggedInUserProfileView = openOnLeft
      this.activeProfileSidebar = !this.activeProfileSidebar
    },
    toggleIsChatPinned (value) {
      this.isChatPinned = value
    },
    setSidebarWidth () {
      if (this.windowWidth < 991) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    closeChatList () {
      if (window.matchMedia('(max-width: 991px)').matches) {
        this.chatSidebarShow = false
      }
      if (this.$route.path.includes('dashboard')) {
        this.chatSidebarShow = false
      }
    },
    toggleChatSidebar (value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    },

    selectGrp (type) {
      this.grpChatActive = true
      this.chatDropdown = false
      if (type === 0) {
        this.userGrp = false
        this.clientGrp = false
        this.chatModal = true
      }
    },
    async createChatGroup () {
      
      const selected_group_user = this.selectedUsers1.map((user) => {
        const user_id  = user.user_id
        return {
          user_id,
          type:'User'
        }
      })

      const selected_group_client = this.selectedClients1.map((client) => {
        const user_id  = client.user_id
        return {
          user_id,
          type:'Client'
        }
      })

      // 
      // 
      const group_user_client = selected_group_user.concat(selected_group_client) 
      // 

      const payload = {
        'group_name' : this.groupName,
        'customer_id' : localStorage.getItem('customer_id'),
        'user_list' : group_user_client,
        'created_by_type' : 'User',
        'group_picture' : 'https://scoolio-files.s3.ap-south-1.amazonaws.com/20201027120008350001/Default/7eWD1zcDwXfAbGLL.png',
        'message_type': this.relatedTo
      }
      // 
      try {
        const data = await createChatGroup(payload)
        
        this.SET_ACTIVE_TAB(2)
        this.fetchThreads()
        this.clearChatSelectionDetails()
      } catch (e) {
        
        if (e.data.errors.group_name[0] === 'The group name must be at least 5 characters.') {
          this.$vs.notify({
            title: 'Warning',
            text: e.data.errors.group_name[0],
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        }
      }
      
    },
    closeSelectedUsers (index) {
      this.selectedUsers.splice(index, 1)
    },
    closeSelectedClients (index) {
      this.selectedClients.splice(index, 1)
    },
    closeSelectedUsers1 (index) {
      this.selectedUsers1.splice(index, 1)
    },
    closeSelectedClients1 (index) {
      this.selectedClients1.splice(index, 1)
    }
  },
  components: {
    VuePerfectScrollbar,
    chatGroup,
    ChatContact,
    UserProfile,
    ChatNavbar,
    ChatLog,
    chatInput,
    messageLog
  },
  created () {
    this.$store.registerModule('chat', moduleChat)
    this.$store.dispatch('chat/fetchContacts')
    this.$store.dispatch('chat/fetchChatContacts')
    this.$store.dispatch('chat/fetchChats')
    this.setSidebarWidth()
  },
  beforeDestroy () {
    this.$store.unregisterModule('chat')
         
    //Removing all chat module EventBus Listner before chat component is destroyed
    EventBus.$off('singleChatClicked')
    EventBus.$off('readChatMessageEvent')
    EventBus.$off('groupDeleted')
    EventBus.$off('addGroupUser')
    EventBus.$off('groupUserAddedSuccess')
    EventBus.$off('newMessageReceived')

  },
  beforeRouteEnter (to, from, next) {
    // console.log(to, from, next)
    localStorage.setItem('PreviousRoute', from.name)
    next((vm) => {
      vm.from = from
    })
  }
  // mounted () {
  //   this.$store.dispatch('chat/setChatSearchQuery', '')
  // }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
#chat-list-sidebar{
  display: block !important;
}
</style>
